// @ts-check

import ResetGridLink from '~/components/Shared/DataGrid/ResetGridLink';
import { EventNames } from '~/components/Incidents/IncidentDataGrid/IncidentDataGrid.utils';
import { useIncidentDataGridContext } from '~/components/Incidents/IncidentDataGrid/IncidentDataGrid.context';

export default function ResetIncidentGridLink() {
    const { settings } = useIncidentDataGridContext();

    return (
        <ResetGridLink
            settings={settings}
            resetTableEventName={EventNames.RESET_TABLE}
            defaultSortModel={null}            
        />
    );
}
